import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Checkbox,
  HelpBlock,
  Alert,
  Tooltip
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import DatePicker from "react-date-picker";
import { createBrowserHistory } from "history";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";

// include action file for add merchant
import "../../../style/subAdmin/SubAdmin.scss";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import { getMerchantType } from "../../../redux/actions/merchantActions";
import { getDealList } from "../../../redux/actions/dealActions";
import { getCities } from "../../../redux/actions/countryCityActions";
import { getCategories } from "../../../redux/actions/categories";
import {
  add_promo,
  getPromoDetails,
  update_promo
} from "../../../redux/actions/promoActions";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import loader from "../../../style/loader/loader.scss";
import {aclUtil} from "../../util"

const history = createBrowserHistory();

const HorizontalLine = ({}) => <hr />;

let enableBtn = false,
  specificOfferIDChecked = "",
  specificProposalTypeChecked = "";
let isError = false,
  disabled = false,
  submitValue = "Save",
  isLoading = false;
class AddPromo extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    let value = new Date().toISOString();
    super(props);
    this.state = {
      menuKey: 'ADD_PROMO_CODE',
      path: ["Home", "Manage Promo Code", "Add New"],
      links: ["home", "promoList","addPromo"],
      alertMessage: "",
      promoID: "",
      promoCode: "",
      description: "",
      discountAmount: "",
      promoError: {},

      available: "",
      status: "Active",
      allowStoreCredit: "0",
      specificOfferID: "0",
      promoDeal: [],
      minPurchase: "0",
      minPurchaseAmount: "",
      maxPurchase: "0",
      maxPurchaseAmount: "",
      onePerCustomer: "0",
      specificProposalType: "0",
      promoProposalType: [],
      specificMarket: "0",
      promoSpecificMarket: [],
      specificCategory: "0",
      promoCategory: "",
      coupanForGifts: "0",
      merchantTypeData: [],
      dealListData: [],
      citiesList: [],
      catlist: [],
      discountType: "0",
      promoDeallist: [],
      startDateTime: "",
      endDateTime: "",
      show: false,
      disabled: false,
      proposalMessage: "",
      offerMessage: "",
      marketMessage: ""
    };

    this.validate = this.validate.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCheck = this.handleCheck.bind(this);

    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.Clear = this.Clear.bind(this);
  }
  onChangeStartDate = date => { this.setState({ startDateTime: date })};
  onChangeEndDate = date => { this.setState({ endDateTime: date })};
  getValidationPromoCode() {
    if (this.state.promoCode) {
      const length = this.state.promoCode.length;
      if (length !== 0) {
        if (!/^(?![0-9]*$)[a-zA-Z0-9]+$/.test(this.state.promoCode)) {
          return "error";
        }
      }
    }
  }

  //test
  handleChange(e) {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    if (e.target.name === "startDateTime" || e.target.name === "endDateTime") {
      this.setState({ endDateTimeError: "", startDateTimeError: "" });
    }

    if(e.target.name == 'promoCode'){
      this.setState({ [e.target.name]: e.target.value.toUpperCase() });
    }else{
      this.setState({ [e.target.name]: e.target.value });
    }
    
    this.setState({ disabled: false });
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleChangeOnPromoCode(e) {
    this.setState({ [e.target.name]: e.target.value });
    if (e.target.value.length > 20) {
      this.setState({ promoCodeError: "red" });
    } else {
      this.setState({ promoCodeError: "" });
      if (`${e.target.name}Error` !== "") {
        this.setState({ [`${e.target.name}Error`]: "" });
      }
    }
    this.setState({ disabled: false });
  }

  handleCheck(e) {
    if (e.target.checked == true) {
      this.setState({ [e.target.name]: 1 });
    } else {
      this.setState({ [e.target.name]: 0 });
    }
    this.setState({ disabled: false });
  }

  handleCheckOnMinPurchase(e) {
    if (e.target.checked == true) {
      this.setState({ [e.target.name]: 1 });
    } else if (!this.state.minPurchaseAmount) {
      this.setState({ [e.target.name]: 0 });
    }

    this.setState({ disabled: false });
  }

  handleCheckOnMaxPurchase(e) {
    if (e.target.checked == true) {
      this.setState({ [e.target.name]: 1 });
    } else if (!this.state.maxPurchaseAmount) {
      this.setState({ [e.target.name]: 0 });
    }

    this.setState({ disabled: false });
  }

  handleCheckOnSpecificCategory(e) {
    if (e.target.checked == true) {
      this.setState({ [e.target.name]: 1 });
    } else if (this.state.promoCategory == "select") {
      this.setState({ [e.target.name]: 0 });
    }

    this.setState({ disabled: false });
  }

  handleCheckOnSpecificOfferID(e) {
    if (e.target.checked == true) {
      this.setState({ [e.target.name]: 1, promoProposalType: "" });
      if (specificProposalTypeChecked == "true") {
        this.setState({
          offerMessage: "Select either proposal type or offer id!"
        });
        this.setState({ [e.target.name]: 0 });
      } else {
        this.setState({ offerMessage: "Select atleast one offer!" });
      }
    } else {
      this.setState({ [e.target.name]: 0, promoDeallist: [] });
      this.setState({ proposalMessage: "" });

    }
    this.setState({ disabled: false });
  }

  handleCheckOnSpecificProposalType(e) {
    if (e.target.checked == true) {
      this.setState({ [e.target.name]: 1 });
      if (specificOfferIDChecked == "true") {
        this.setState({
          proposalMessage: "Select either proposal type or offer id!"
        });
        this.setState({ [e.target.name]: 0 });
      } else {
        this.setState({ proposalMessage: "Select atleast one proposal type!" });
      }
    } else {
      this.setState({ [e.target.name]: 0, promoProposalType: [] });
      this.setState({ offerMessage: "" });
    }
    this.setState({ disabled: false });
  }

  validate = () => {
    let isError = false;
    const errors = {};

    if (this.state.promoCode.length === 0) {
      isError = true;
      this.setState({ promoCodeError: "red" });
    } else if (this.state.promoCode.length > 0) {
      if (!/^(?![0-9]*$)[a-zA-Z0-9]+$/.test(this.state.promoCode)) {
        isError = true;
        this.setState({ promoCodeError: "red" });
      }
    }
    if (this.state.description.length === 0) {
      isError = true;
      this.setState({ descriptionError: "red" });
    }

    if (!this.state.discountAmount) {
      isError = true;
      this.setState({ discountAmountError: "red" });
    }

    return isError;
  };

  handleSubmit(e) {
    e.preventDefault();
    const err = this.validate();
    if (!err) {
      this.setState({ disabled: true });
      this.handleDismiss();
      const startDate = this.state.startDateTime
        ? this.state.startDateTime
        : null;
      const endDate = this.state.endDateTime ? this.state.endDateTime : null;
      this.handleShow();
      if (this.state.promoID !== "") {
        const startDateTimeConst = this.state.startDateTime
          ?  moment(this.state.startDateTime).format("YYYY-MM-DD")
          : null;
        const endDateTimeConst = this.state.endDateTime
          ? moment(this.state.endDateTime).format("YYYY-MM-DD")
          : null;
        const postData = {
          promoID: this.state.promoID,
          promoCode: this.state.promoCode.toUpperCase(),
          description: this.state.description,
          discountAmount: this.state.discountAmount,
          discountType: this.state.discountType,
          startDateTime: startDateTimeConst,
          endDateTime: endDateTimeConst,
          available: this.state.available,
          status: this.state.status,
          allowStoreCredit: this.state.allowStoreCredit,
          specificOfferID: this.state.specificOfferID,
          promoDeal: this.state.promoDeallist,
          minPurchase: this.state.minPurchase,
          minPurchaseAmount: this.state.minPurchaseAmount,
          maxPurchase: this.state.maxPurchase,
          maxPurchaseAmount: this.state.maxPurchaseAmount,
          onePerCustomer: this.state.onePerCustomer,
          specificProposalType: this.state.specificProposalType,
          promoProposalType: this.state.promoProposalType,
          specificMarket: this.state.specificMarket,
          promoSpecificMarket: this.state.promoSpecificMarket,
          specificCategory: this.state.specificCategory,
          promoCategory: this.state.promoCategory,
          coupanForGifts: this.state.coupanForGifts
        };
        this.props.update_promo(postData);
      } else {
        const postData = {
          promoID: this.state.promoID,
          promoCode: this.state.promoCode.toUpperCase(),
          description: this.state.description,
          discountAmount: this.state.discountAmount,
          discountType: this.state.discountType,
          startDateTime: startDate,
          endDateTime: endDate,
          available: this.state.available,
          status: this.state.status,
          allowStoreCredit: this.state.allowStoreCredit,
          specificOfferID: this.state.specificOfferID,
          promoDeal: this.state.promoDeallist,
          minPurchase: this.state.minPurchase,
          minPurchaseAmount: this.state.minPurchaseAmount,
          maxPurchase: this.state.maxPurchase,
          maxPurchaseAmount: this.state.maxPurchaseAmount,
          onePerCustomer: this.state.onePerCustomer,
          specificProposalType: this.state.specificProposalType,
          promoProposalType: this.state.promoProposalType,
          specificMarket: this.state.specificMarket,
          promoSpecificMarket: this.state.promoSpecificMarket,
          specificCategory: this.state.specificCategory,
          promoCategory: this.state.promoCategory,
          coupanForGifts: this.state.coupanForGifts
        };
        this.props.add_promo(postData);
        enableBtn = true;
      }
    }
  }

  Clear() {
    (this.state.promoCode = ""),
      (this.state.description = ""),
      (this.state.discountAmount = ""),
      (this.state.discountType = "0"),
      (this.state.startDateTime = ""),
      (this.state.endDateTime = ""),
      (this.state.available = ""),
      (this.state.status = "Active"),
      (this.state.allowStoreCredit = "0"),
      (this.state.specificOfferID = "0"),
      (this.state.promoDeallist = ""),
      (this.state.minPurchase = "0"),
      (this.state.minPurchaseAmount = ""),
      (this.state.maxPurchase = "0"),
      (this.state.maxPurchaseAmount = ""),
      (this.state.onePerCustomer = "0"),
      (this.state.specificProposalType = "0"),
      (this.state.promoProposalType = ""),
      (this.state.specificMarket = "0"),
      (this.state.promoSpecificMarket = ""),
      (this.state.specificCategory = "0"),
      (this.state.promoCategory = ""),
      (this.state.coupanForGifts = "0");
  }

  componentWillMount() {
    this.handleDismiss();
    this.props.clearAlert();
    this.props.getMerchantType();
    this.props.getDealList({page: 0});
    const formData = {
      page: 0
    };
    this.props.getCities(formData);
    this.props.getCategories();
    let promoIdParams = this.props.match.params.promoID
      ? this.props.match.params.promoID
      : "";
    const editLink = this.props.match.params.promoID && `addPromo/${this.props.match.params.promoID}`
    if (promoIdParams !== "") {
      isLoading = true;
      disabled = true;
      this.props.getPromoDetails(promoIdParams);
      this.state.links = ["home", "promoList", editLink];
      this.state.path = ["Home", "Manage Promo", "Edit Promo"];
    }
  }

  componentWillReceiveProps(nextProps) {

    let tmpAclKey = this.state.menuKey;
    if(this.props.match.params.promoID){
      tmpAclKey = 'EDIT_PROMO_CODE';
    }
    if(!aclUtil.isPrimaryMenuAccessible(tmpAclKey)){
      this.context.router.history.push("/restrictedAccess");
    }
    
    if (this.props.merchantType !== nextProps.merchantType) {
      if (nextProps.merchantType) {
        this.setState({ merchantTypeData: nextProps.merchantType });
      }
    }
    if (this.props.dealList !== nextProps.dealList) {
      if (nextProps.dealList && nextProps.dealList) {
        this.setState({ dealListData: nextProps.dealList });
      }
    }
    if (this.props.cities !== nextProps.cities) {
      if (nextProps.cities) {
        this.setState({ citieslist: nextProps.cities });
      }
    }
    if (this.props.catData !== nextProps.catData) {
      if (nextProps.catData) {
        this.setState({ catList: nextProps.catData.data });
      }
    }

    if (this.props.promoResponse !== nextProps.promoResponse) {
      if (nextProps.promoResponse) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.promoResponse.message);
        this.setState({ disabled: false });
        isLoading = false;
        this.Clear();
        window.scrollTo(0, 0);
      }
    }

    if (nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }

    if (this.props.updatedPromo !== nextProps.updatedPromo) {
      if (nextProps.updatedPromo) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.updatedPromo.message);
        this.setState({ disabled: false });
        isLoading = false;
        this.props.getPromoDetails(this.state.promoID);
        window.scrollTo(0, 0);
      }
    }
    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.props.clearAlert();
        this.props.renderAlert("warning", nextProps.error);
        window.scrollTo(0, 0);
      }
    }

    let promoDeallist = [],
      promoProposalType = [],
      promoSpecificMarket = [];
    if (this.props.promoDetail !== nextProps.promoDetail) {
      if (nextProps.promoDetail) {
        let promo = nextProps.promoDetail;
        if (promo) {
          this.setState({ disabled: false });
          isLoading = false;
        }
        this.setState({
          promoID: promo.promoID,
          promoCode: promo.promoCode,
          description: promo.description,
          discountAmount: promo.discountAmount,
          discountType: promo.discountType,
          available: promo.available,
          startDateTime: (promo.startDateTime) ? new Date(moment(promo.startDateTime).format('YYYY-MM-DD')) : "",
          endDateTime: (promo.endDateTime) ? new Date(moment(promo.endDateTime).format('YYYY-MM-DD')) : "",
          status: promo.status,
          allowStoreCredit: promo.allowStoreCredit,
          minPurchase: promo.minPurchase,
          minPurchaseAmount: promo.minPurchaseAmount,
          maxPurchase: promo.maxPurchase,
          maxPurchaseAmount: promo.maxPurchaseAmount,
          onePerCustomer: promo.onePerCustomer,
          specificProposalType: promo.specificProposalType,
          specificStores: promo.specificStores,
          specificOfferID: promo.specificOfferID,
          specificMarket: promo.specificMarket,
          specificCategory: promo.specificCategory,
          coupanForGifts: promo.coupanForGifts,
          promoCategory: promo.promoCategory
        });

        if (promo.promoDeals) {
          promo.promoDeals.map((promodeal, index) =>
            promoDeallist.push(promodeal.dealID)
          );
        }
        this.setState({ promoDeallist: promoDeallist });

        if (promo.promoProposals) {
          promo.promoProposals.map((promoproposal, index) =>
            promoProposalType.push(promoproposal.merchantTypeID)
          );
          this.setState({ promoProposalType: promoProposalType });
        }
        if (promo.promoSpecificMarkets) {
          promo.promoSpecificMarkets.map((promomarket, index) =>
            promoSpecificMarket.push(promomarket.cityID)
          );
          this.setState({ promoSpecificMarket: promoSpecificMarket });
        }
      }
    }
  }

  handleListChange(e) {
    let options = e.target.options;
    var value = [];
    for (var i = 0, l = options.length; i < l; i++) {
      if (options[i].selected) {
        value.push(options[i].value);
      }
    }
    this.setState({
      [e.target.name]: value,
      proposalMessage: "",
      marketMessage: ""
    });
    this.setState({ disabled: false });
  }

  handleCheckOnSpecificMarket(e) {
    if (e.target.checked == true) {
      this.setState({
        [e.target.name]: 1,
        marketMessage: "Select atlest one market"
      });
    } else {
      this.setState({ [e.target.name]: 0, promoSpecificMarket: [] });
    }

    this.setState({ disabled: false });
  }

  handleListChangeOnDeal(e) {
    let options = e.target.options;
    var value = [];
    for (var i = 0, l = options.length; i < l; i++) {
      if (options[i].selected) {
        value.push(options[i].value);
      }
    }
    this.setState({ promoDeallist: value, offerMessage: "" });
    this.setState({ disabled: false });
  }

  handleSelectionChange = promoDeal => {
    this.setState({ promoDeal });
    this.setState({ disabled: false });
  };

  handleChangeOnEndDate(date) {
    this.setState({
      endDateTime: date
    });
  }

  handleChangeOnStartDate(date) {
    this.setState({
      startDateTime: date
    });
  }

  getValidationState() {
    const length = this.state.promoCode.length;
    if (length <= 20 && length !== 0) return "success";
    else if (length > 20) return "error";

    return null;
  }

  getValidationSDateState() {
    const sDate = moment(this.state.startDateTime).format("YYYY-MM-DD");
    const eDate = moment(this.state.endDateTime).format("YYYY-MM-DD");
    if (this.state.endDateTime && this.state.startDateTime) {
      if (sDate > eDate) return "error";
    }
    if (!this.state.startDateTime && this.state.endDateTime) return "error";

    return null;
  }

  getValidationEDateState() {
    const sDate = moment(this.state.startDateTime).format("YYYY-MM-DD");
    const eDate = moment(this.state.endDateTime).format("YYYY-MM-DD");
    if (this.state.endDateTime && this.state.startDateTime) {
      if (eDate < sDate) return "error";
    }
    if (!this.state.endDateTime && this.state.startDateTime) return "error";

    return null;
  }

  handleCancel() {
    disabled = false;
    this.Clear();
  }

  onStartDateTimeBlur = e => {
    e.preventDefault();
    const startDate = moment(this.state.startDateTime).format("YYYY-MM-DD");
    const endDate = moment(this.state.endDateTime).format("YYYY-MM-DD");
    if (this.state.endDateTime && this.state.startDateTime) {
      if (startDate > endDate) {
        this.setState({
          startDateTimeError: "Start date should be less than end date!"
        });
      }else{
        this.setState({
          startDateTimeError: ""
        });
      }
    }
  };
  onEndDateTimeBlur = e => {
    e.preventDefault();
    const startDate = moment(this.state.startDateTime).format("YYYY-MM-DD");
    const endDate = moment(this.state.endDateTime).format("YYYY-MM-DD");
    if (this.state.startDateTime && this.state.endDateTime) {
      if (startDate > endDate) {
        this.setState({
          endDateTimeError: "End date should be greater than start date!"
        });
      }else{
         this.setState({
          endDateTimeError: ""
        });
      }
    }
  };

  render() {

    let errormsg = this.props.failuremessage ? this.props.failuremessage : "";
    if (errormsg) {
      disabled = false;
    }

    let listpromoSpecificMarket = [];
    if (this.state.promoSpecificMarket) {
      this.state.promoSpecificMarket.map((promomarket, index) =>
        listpromoSpecificMarket.push(promomarket.cityID)
      );
    }

    let dealOfferlist = this.state.dealListData ? this.state.dealListData : [];
    let deallistdata = [];
    if (dealOfferlist) {
      deallistdata = dealOfferlist.map((el, idx) => (
        <option key={el.dealID} value={el.dealID}>
          {el.dealText} ({el.merchantName})
        </option>
      ));
    }

    let merchantTypeData = this.state.merchantTypeData
      ? this.state.merchantTypeData
      : [];
    let merchantlist = [];
    if (merchantTypeData) {
      merchantlist = merchantTypeData.map((el, idx) => (
        <option key={el.merchantTypeID} value={el.merchantTypeID}>
          {el.merchantTypeName}
        </option>
      ));
    }

    let citieslistData = this.state.citieslist ? this.state.citieslist : [];
    let citylist = [];
    if (citieslistData) {
      citylist = citieslistData.map((el, idx) => (
        <option key={el.cityID} value={el.cityID}>
          {el.title}
        </option>
      ));
    }

    let catListData =
      this.state.catList && this.state.catList.data
        ? this.state.catList.data
        : [];
    let categorylist;
    if (catListData) {
      categorylist = catListData.map((el, idx) => (
        <option key={el.catID} value={el.catID}>
          {el.catName}
        </option>
      ));
    }

    specificOfferIDChecked = this.state.specificOfferID == "1" ? "true" : "";
    let minPurchaseChecked = this.state.minPurchase == "1" ? "true" : "";
    let maxPurchaseChecked = this.state.maxPurchase == "1" ? "true" : "";
    let onePerCustomerChecked = this.state.onePerCustomer == "1" ? "true" : "";
    specificProposalTypeChecked =
      this.state.specificProposalType == "1" ? "true" : "";
    let specificMarketChecked = this.state.specificMarket == "1" ? "true" : "";
    let specificCategoryChecked =
      this.state.specificCategory == "1" ? "true" : "";
    let coupanForGiftsChecked = this.state.coupanForGifts == "1" ? "true" : "";

    let enableMinPurchase = minPurchaseChecked == "true" ? false : true;
    let enablemaxPurchase = maxPurchaseChecked == "true" ? false : true;
    let enableonePerCustomer = onePerCustomerChecked == "true" ? false : true;
    let enablespecificProposalType =
      specificProposalTypeChecked == "true" ? false : true;
    let enablespecificMarket = specificMarketChecked == "true" ? false : true;
    let enablespecificCategory =
      specificCategoryChecked == "true" ? false : true;
    let enablecoupanForGifts = coupanForGiftsChecked == "true" ? false : true;
    let enablespecificOfferID = specificOfferIDChecked == "true" ? false : true;

    return (
      <div className="col-lg-12 add-sub-admin">
        <div>
          {isLoading == true ? (
            <div className="loader">
              <p className="loading-message">
                <i>Loading...</i>
              </p>
              <div className="spinner">
                <div className="dot1" />
                <div className="dot2" />
              </div>
            </div>
          ) : (
            ""
          )}
          <form onSubmit={this.handleSubmit}>
            <div className="row">
              <div className="col-xs-12">
                <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
              </div>
            </div>
            {/**start promo code information **/}
            <div className="panel">
              <header className="panel-heading">Promo Code Details</header>

              {this.state.show &&
                this.state.alertMessage !== "" && (
                  <div className="col-lg-12">
                    <Alert
                      bsStyle={this.state.msgType}
                      onDismiss={this.handleDismiss}
                    >
                      <strong>{this.state.msgType}:</strong>{" "}
                      {this.state.alertMessage}
                    </Alert>
                  </div>
                )}

              <div className="panel-body">
                <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <Row>
                    <Col md={6} xs={12}>
                      <ControlLabel>
                        {" "}
                        <span style={{ color: "red" }}>*</span> Promo
                        Code(format:Lorem123 or Lorem)
                      </ControlLabel>
                      <FormGroup
                        controlId="formPromoCode"
                        validationState={this.getValidationPromoCode()}
                      >
                        <FormControl
                          type="text"
                          value={this.state.promoCode}
                          placeholder="Promo Code"
                          onChange={this.handleChange}
                          name="promoCode"
                          style={{ borderColor: this.state.promoCodeError }}
                        />
                      </FormGroup>
                      <FormGroup controlId="formDiscountAmount">
                        <ControlLabel>
                          {" "}
                          <span style={{ color: "red" }}>*</span> Discount Value
                        </ControlLabel>

                        <FormControl
                          className="halfWidth"
                          type="number"
                          value={this.state.discountAmount}
                          placeholder="Discount Value"
                          onChange={this.handleChange}
                          name="discountAmount"
                          style={{
                            borderColor: this.state.discountAmountError
                          }}
                        />
                      </FormGroup>
                      <FormGroup controlId="formDiscountType">
                        <ControlLabel>Discount Type</ControlLabel>
                        <FormControl
                          className="halfWidth"
                          componentClass="select"
                          name="discountType"
                          onChange={this.handleChange}
                          value={this.state.discountType}
                        >
                          <option value="0">$</option>
                          <option value="1">%</option>
                        </FormControl>
                      </FormGroup>
                      <FormGroup controlId="formAvailable">
                        <ControlLabel>Available</ControlLabel>
                        <FormControl
                          type="text"
                          value={this.state.available}
                          placeholder="Available"
                          onChange={this.handleChange}
                          name="available"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6} xs={12}>
                      <ControlLabel className="halfWidth">
                        Start Date
                      </ControlLabel>
                      <FormGroup
                        controlId="formStartDateTime"
                        validationState={this.getValidationSDateState()}
                        onBlur={this.onStartDateTimeBlur.bind(this)}
                      >
                        {/*<FormControl
                                                  className="form-control datepicker"
                                                  type="date"
                                                  value={this.state.startDateTime}
                                                  placeholder="MM-DD-YYYY"
                                                  onChange={this.handleChange}
                                                  name="startDateTime"
                                                  onBlur={this.onStartDateTimeBlur.bind(this)}
                                                />*/}
                        <DatePicker
                          onChange={this.onChangeStartDate}
                          value={this.state.startDateTime}
                        />
                        {this.state.startDateTimeError && (
                          <Tooltip
                            placement="bottom"
                            className="in"
                            id="tooltip-bottom"
                          >
                            {this.state.startDateTimeError}
                          </Tooltip>
                        )}
                      </FormGroup>
                      <ControlLabel className="halfWidth">
                        End Date
                      </ControlLabel>
                      <FormGroup
                        controlId="formEndDateTime"
                        validationState={this.getValidationEDateState()}
                        onBlur={this.onEndDateTimeBlur.bind(this)}
                      >
                        {/*<FormControl
                                                  className="form-control datepicker"
                                                  type="date"
                                                  value={this.state.endDateTime}
                                                  placeholder="MM-DD-YYYY"
                                                  onChange={this.handleChange}
                                                  name="endDateTime"
                                                  onBlur={this.onEndDateTimeBlur.bind(this)}
                                                />*/}
                        <DatePicker
                          onChange={this.onChangeEndDate}
                          value={this.state.endDateTime}
                        />
                        {this.state.endDateTimeError && (
                          <Tooltip
                            placement="bottom"
                            className="in"
                            id="tooltip-bottom"
                          >
                            {this.state.endDateTimeError}
                          </Tooltip>
                        )}

                      </FormGroup>

                      <FormGroup controlId="formStatus">
                        <ControlLabel>Status</ControlLabel>
                        <FormControl
                          componentClass="select"
                          name="status"
                          onChange={this.handleChange}
                          value={this.state.status}
                        >
                          <option value="Active">Active</option>
                          <option value="Inactive">Inactive</option>
                        </FormControl>
                      </FormGroup>

                      <FormGroup controlId="formDescription">
                        <ControlLabel>
                          <span style={{ color: "red" }}>*</span> Description
                        </ControlLabel>
                        <FormControl
                          componentClass="textarea"
                          value={this.state.description}
                          name="description"
                          style={{ borderColor: this.state.descriptionError }}
                          placeholder="Description"
                          onChange={this.handleChange}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
            {/**end promo code information **/}

            {/**start promo code promotion details **/}
            <div className="panel">
              <header className="panel-heading">
                Promo Code Promotion Detail
              </header>
              <div className="panel-body">
                <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <Row>
                    <Col md={6} xs={12}>
                      <FormGroup controlId="formExpirationMonth">
                        <ControlLabel>Allow Store Credit?</ControlLabel>
                        <FormControl
                          componentClass="select"
                          name="allowStoreCredit"
                          onChange={this.handleChange}
                          value={this.state.allowStoreCredit}
                        >
                          <option value="0">No</option>
                          <option value="1">Yes</option>
                        </FormControl>
                      </FormGroup>

                      <FormGroup controlId="formMinPurchase">
                        <ControlLabel>
                          <Checkbox
                            className="checkBox"
                            name="minPurchase"
                            checked={minPurchaseChecked}
                            value={this.state.minPurchase}
                            onChange={this.handleCheckOnMinPurchase.bind(this)}
                            inline
                          >
                            Minimum Purchase
                          </Checkbox>
                        </ControlLabel>
                        <FormControl
                          type="number"
                          value={this.state.minPurchaseAmount}
                          placeholder="Minimum Purchase Amount in $"
                          onChange={this.handleChange}
                          name="minPurchaseAmount"
                          disabled={enableMinPurchase}
                        />
                      </FormGroup>

                      <FormGroup controlId="formMaxPurchase">
                        <ControlLabel>
                          <Checkbox
                            className="checkBox"
                            name="maxPurchase"
                            checked={maxPurchaseChecked}
                            value={this.state.maxPurchase}
                            onChange={this.handleCheckOnMaxPurchase.bind(this)}
                            inline
                          >
                            Maximum Purchase
                          </Checkbox>
                        </ControlLabel>
                        <FormControl
                          type="number"
                          value={this.state.maxPurchaseAmount}
                          placeholder="Maximum Purchase Amount in $"
                          onChange={this.handleChange}
                          name="maxPurchaseAmount"
                          disabled={enablemaxPurchase}
                        />
                      </FormGroup>

                      <FormGroup controlId="formSpecificCategory">
                        <ControlLabel>
                          <Checkbox
                            className="checkBox"
                            name="specificCategory"
                            checked={specificCategoryChecked}
                            value={this.state.specificCategory}
                            onChange={this.handleCheckOnSpecificCategory.bind(
                              this
                            )}
                            inline
                          >
                            Specific Category
                          </Checkbox>
                        </ControlLabel>
                        <FormControl
                          componentClass="select"
                          name="promoCategory"
                          onChange={this.handleChange}
                          value={this.state.promoCategory}
                          disabled={enablespecificCategory}
                        >
                          <option value="select">Select Category</option>
                          {categorylist}
                        </FormControl>
                      </FormGroup>

                      <FormGroup controlId="formCoupanForGifts">
                        <ControlLabel>Is this a coupon for gifts?</ControlLabel>
                        <FormControl
                          componentClass="select"
                          name="coupanForGifts"
                          value={this.state.coupanForGifts}
                          onChange={this.handleChange}
                        >
                          <option value="0">No</option>
                          <option value="1">Yes</option>
                        </FormControl>
                      </FormGroup>
                    </Col>

                    <Col md={6} xs={12}>
                      {this.state.offerMessage && (
                        <Tooltip
                          placement="bottom"
                          className="in"
                          id="tooltip-bottom"
                          style={{top: '-16px'}}
                        >
                          {this.state.offerMessage}
                        </Tooltip>
                      )}
                      <FormGroup controlId="formSpecificOfferID">
                        {/* <ControlLabel> */}
                        <Checkbox
                          className="checkBox"
                          name="specificOfferID"
                          checked={specificOfferIDChecked}
                          value={this.state.specificOfferID}
                          onChange={this.handleCheckOnSpecificOfferID.bind(
                            this
                          )}
                          inline
                        >
                          Specific Offer ID?
                        </Checkbox>
                        {/* </ControlLabel> */}
                        <FormControl
                          name="promoDeallist"
                          componentClass="select"
                          onChange={this.handleListChangeOnDeal.bind(this)}
                          value={this.state.promoDeallist}
                          disabled={enablespecificOfferID}
                          multiple
                        >
                          <option value="select">select (multiple)</option>

                          {deallistdata}
                        </FormControl>
                      </FormGroup>

                      <FormGroup controlId="formMarketMessageID">
                        {this.state.marketMessage && (
                          <Tooltip
                            style={{bottom: '242px'}}
                            placement="bottom"
                            className="in"
                            id="tooltip-bottom"
                          >
                            {this.state.marketMessage}
                          </Tooltip>
                        )}
                        {/* <ControlLabel> */}
                        <Checkbox
                          className="checkBox"
                          name="specificMarket"
                          checked={specificMarketChecked}
                          value={this.state.specificMarket}
                          onChange={this.handleCheckOnSpecificMarket.bind(this)}
                          inline
                        >
                          Specific Market
                        </Checkbox>
                        {/* </ControlLabel> */}
                        <FormControl
                          componentClass="select"
                          name="promoSpecificMarket"
                          onChange={this.handleListChange.bind(this)}
                          value={this.state.promoSpecificMarket}
                          disabled={enablespecificMarket}
                          multiple
                        >
                          <option value="select">select (multiple)</option>
                          {citylist}
                        </FormControl>
                      </FormGroup>

                      {/* <FormGroup controlId="formSpecificPercustomer"> */}
                      {/* <ControlLabel> */}
                      <Checkbox
                        className="checkBox"
                        name="onePerCustomer"
                        checked={onePerCustomerChecked}
                        value={this.state.onePerCustomer}
                        onChange={this.handleCheck}
                        inline
                      >
                        One Per Customer
                      </Checkbox>
                      {/* </ControlLabel> */}
                      {/* </FormGroup> */}

                      {this.state.proposalMessage && (
                        <Tooltip
                          style={{bottom:'98px'}}
                          placement="bottom"
                          className="in"
                          id="tooltip-bottom"
                        >
                          {this.state.proposalMessage}
                        </Tooltip>
                      )}
                      <FormGroup controlId="formSpecificProposalType">
                        <ControlLabel>
                          <Checkbox
                            className="checkBox"
                            name="specificProposalType"
                            checked={specificProposalTypeChecked}
                            value={this.state.specificProposalType}
                            onChange={this.handleCheckOnSpecificProposalType.bind(
                              this
                            )}
                            inline
                          >
                            Specific Proposal Type
                          </Checkbox>
                        </ControlLabel>
                        <FormControl
                          componentClass="select"
                          name="promoProposalType"
                          onChange={this.handleListChange.bind(this)}
                          value={this.state.promoProposalType}
                          disabled={enablespecificProposalType}
                          multiple
                        >
                          <option value="select">select (multiple)</option>
                          {merchantlist}
                        </FormControl>
                      </FormGroup>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
            {/**end promo code promotion details **/}

            <Row className="BtnRow">
              <Col md={12} xs={12}>
                <Button
                  bsStyle="info"
                  type="submit"
                  id="saveButton"
                  disabled={this.state.disabled}
                >
                  {submitValue}
                </Button>
                <Button
                  bsStyle="default"
                  onClick={() => this.context.router.history.push(`/promoList`)}
                >
                  Cancel
                </Button>
              </Col>
            </Row>
          </form>
        </div>

        {/* }  */}
      </div>
    );
  }
}

AddPromo.propTypes = {
  getDealList: PropTypes.func.isRequired,
  getCities: PropTypes.func.isRequired,
  getCategories: PropTypes.func.isRequired,
  getMerchantType: PropTypes.func.isRequired,
  add_promo: PropTypes.func.isRequired,
  getPromoDetails: PropTypes.func.isRequired,
  update_promo: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  return {
    merchantType: state.merchantReducer.merchantType,
    dealList: state.dealReducer.dealList,
    cities: state.countryCityReducers.activecities,
    catData: state.categoryReducer.catData,
    promoResponse: state.promoReducer.promoResponse,
    promoDetail: state.promoReducer.promoDetail,
    updatedPromo: state.promoReducer.updatedPromo,
    error: state.promoReducer.error,
    failuremessage: state.promoReducer.failuremessage,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message
  };
};

export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps, {
    getDealList,
    getCities,
    getCategories,
    renderAlert,
    clearAlert,
    getMerchantType,
    add_promo,
    getPromoDetails,
    update_promo
  })
)(AddPromo);



// WEBPACK FOOTER //
// ./src/app/views/admin/promoCode/AddPromo.js